import dynamic from 'next/dynamic'

import { Footer } from '@fe-toolkit/web-components/ssr'
import { footerLinks } from '@fe-toolkit/utility'

import { useChromeFlags } from '@/layouts/Main/ChromeFlagsContext'

// Loaded only when it renders, so Tamagui stays out of the main bundle.
const BrandRefreshFooter = dynamic(() =>
  import('@/components/brandRefresh/BrandRefreshChrome').then(m => m.BrandRefreshFooter),
)

// Full-nav degraded Footer used when the fe_common remote is unavailable. Brand Refresh picks the design
// system Footer over the legacy one, as fe-common does. Shared by next/dynamic `loading`, the
// FederatedComponentBoundary fallback, and the errorLoadRemote registry (mfOfflineHandlingPlugin.js) so the
// degraded UI is identical whichever failure mode fires.
export default function FallbackFooter() {
  const { isBrandRefresh } = useChromeFlags()

  return isBrandRefresh ? <BrandRefreshFooter /> : <Footer links={footerLinks} />
}
